import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import Clarity from '@microsoft/clarity';
import { isNullOrUndefined } from '../utils/is-null-or-undefined';

@Injectable({
  providedIn: 'root'
})
export class MsClarityService {

  constructor() { }

  public setup(): void {
    if (!this.clarityEnabled()) {
      return;
    }

    // console.log('Clarity Enabled:', environment.msClarityProjectId);
    Clarity.init(environment.msClarityProjectId);
  }

  /**
   * Used for tracking the specific logged-in user.
   * Must be called everytime the user logs in.
   *
   * @param email
   * @param name
   */
  public identify(email: string, name: string): void {
    if (!this.clarityEnabled()) {
      return;
    }

    Clarity.identify(email, null, null, name);
  }

  /**
   * Used for tracking mainly when the user is not logged in.
   * Called after log out.
   */
  public identifyAsGust(): void {
    if (!this.clarityEnabled()) {
      return;
    }

    Clarity.identify('guest', null, null, 'guest');
  }

  private clarityEnabled(): boolean {
    // return true;
    return environment.production && environment.msClarityEnabled && !isNullOrUndefined(environment.msClarityProjectId);
  }
}
